import { navigate } from "gatsby"
import { call } from "redux-saga/effects"

export default function* handleRedirect404(action) {
  yield call(navigate, "/404")
}
